// Admin Auth
export const ADMIN_LOGIN_DETAILS = "auth/login";

//Category
export const ADD_NEW_CATEGORY = "category";
export const GET_ALL_CATEGORY = "category";
export const UPDATE_CATEGORY = "category";
export const DELETE_CATEGORY_BY_ID = "category";
export const GET_CATEGORY_BY_ID = "category/byid";


//Instructor
export const ADD_NEW_INSTRUCTOR = "instructors/create";
export const GET_ALL_INSTRUCTORS = "instructors";
export const APPROVE_INSTRUCTOR = "instructors/approve-deny";
export const GET_INSTRUCTOR_DROPDOWN = "instructors/dropdown"
export const UPDATE_INSTRUCTORS = "instructors/manage";
export const GET_INSTRUCTOR_SLOTS = "instructors/slots"
export const GET_AVAILABLE_INSTRUCTOR_SLOTS = "instructors/available-slots"
export const GET_ASSIGNED_CLASSES = "instructors/assigned-classes"
export const UPDATE_INSTRUCTOR_SLOTS = "instructors/update-slots"
export const CREATE_OFFLINE_CLASS_PRICE = "classes/offline/class-price";
export const UPDATE_OFFLINE_CLASS_PRICE = "classes/offline/class-price";
export const DEACTIVATE_INSTRUCTOR = "instructors/toggle-activation";

// get /FreessessionRequests
export const GET_FREE_SESSIONS = "booking/freesessionrequests";
export const UPDATE_FREE_SESSIONS = "booking/freesessionrequest";
export const DELETE_FREE_SESSIONS = "booking/free-session-request";
export const GET_FREE_SESSION_COUNT = "booking/freesessionrequest/count";
export const MARK_FREE_SESSIONS_READ = "booking/freesessionrequest/read";
export const GET_NOTIFICATION_COUNTS = "notifications/counts";




//class

export const GET_ALL_CLASSESS = "classes";
export const DELETE_CLASS_BY_ID = "classes";
export const ADD_NEW_CLASS = "classes"
export const GET_CATEGORY_DROPDOWN = "classes/categories/dropdown"
export const UPDATE_CLASS = "classes"
export const GET_OFFLINE_CLASS_PRICES = "classes/offline/class-price";

// Transfer
export const GET_TRANSFER_STUDENTS = "classes/transfer/students";
export const GET_TRANSFER_AVAILABLE_TARGETS = "classes/transfer/available-targets";
export const POST_TRANSFER_USERS = "classes/transfer/users";
export const POST_TRANSFER_ALL_USERS = "classes/transfer/all-users";



//students

export const GET_ALL_ACTIVE_STUDENTS = "student/activebooking"
export const GET_STUDENT_MEDICAL_DETAILS = "student/profile/detail"
export const GET_STUDENT_ONLINE_CURRENT_DETAILS = "student/online/current"
export const GET_STUDENT_ONLINE_PAST_DETAILS = "student/online/past"
export const GET_STUDENT_OFFLINE_CURRENT_DETAILS = "student/offline/current"
export const GET_STUDENT_OFFLINE_PAST_DETAILS = "student/offline/past"
export const ADD_NEW_LEAD_STUDENT = "student/add-user"
export const SET_STUDENT_PASSWORD = "student/set-password"
export const GET_PENDING_INVITES = "student/pending-invites"
export const RESEND_INVITE = "student/resend-invite"
export const EDIT_LEAD_STUDENT = "student/edit-student"
export const DELETE_LEAD_STUDENT = "student/delete-student"
export const SETUP_ROLL_NUM_PREFIX = "student/setup-rollno-prefix"
export const ROLL_NUM_PREFIX_CONFIGURATION = "student/rollno-prefix-config"

//bookings

export const GET_ALL_BOOKINGS = "booking/bookedclassdetail"
export const GET_ALL_BOOKINGS_OFFLINE = "booking/offline-instructor/all"
export const GET_ALL_CLASSESS_COUNT = "booking/bookedclasscounts"
export const GET_ALL_CLASSESS_COUNT_PAST = "booking/pastclassbookings"
export const GET_ALL_CLASSESS_COUNT_CURRENT = "booking/currentclassbookings"
export const GET_ALL_CLASSESS_COUNT_OFFLINE = "booking/offline/counts"
export const GET_ALL_CLASSESS_COUNT_OFFLINE_PAST = "booking/pastofflineinstructorbookings"
export const GET_ALL_CLASSESS_COUNT_OFFLINE_CURRENT = "booking/currentOfflineinstructorbookings"


// calender
export const GET_ALL_CALENDERDATA = "classes/calendar"

// Reschedule

export const GET_ALL_RESCHEDULELIST = "classes/rescheduled"
export const APPROVED_RESCHEDULE_CLASS = "classes/approve-reschedule"

//Dashboad

export const GET_ALL_DASHBOARD_DATA = "dashboard"
export const GET_ALL_DASHBOARD_DATA_OFFLINE = "dashboard/offline"

//Enquiry


export const GET_ALL_ENQUIRY_LIST = "demo/enquiries"
export const DELETE_ENQUIRY_BY_ID = "demo/enquiry"
export const UPDATE_ENQUIRY_BY_ID = "demo/enquiry"
export const GET_INSTRUCTOR_PAYMENTS = "instructors/admin/payments";
export const UPDATE_INSTRUCTOR_COMMISSION = "instructors/update-commission-payment";

//Bank Details EndPoints
export const GET_INSTRUCTOR_BANK_DETAILS = "bankDetails";
export const GET_INSTRUCTOR_PROFILE = "instructors/profile-summary";
export const GET_ADMIN_BANK_DETAILS = "bankDetails/admin";
export const UPDATE_ADMIN_BANK_DETAILS = "bankDetails";
export const UPDATE_PAYMENT_STATUS = "instructors/settle-payment";

// Daylight Classes
export const GET_ALL_DAYLIGHT_CLASSES = "classes/daylightclasses";
export const ADD_NEW_DAYLIGHT_CLASS = "classes/daylightclasses";
export const UPDATE_DAYLIGHT_CLASS = "classes/daylightclasses";
export const DELETE_DAYLIGHT_CLASS_BY_ID = "classes/daylightclasses";

// Application Toggle
export const APP_TOGGLE_REQUEST_OTP = "application-toggle/mode/request-otp";
export const APP_TOGGLE_VERIFY = "application-toggle/mode/verify";
export const APP_TOGGLE_CURRENT = "application-toggle/mode/current";

// Coupons
export const CREATE_COUPON = "coupons";
export const GET_ALL_COUPONS = "coupons";
export const ASSIGN_COUPON = "coupons/assign";
export const UNASSIGN_COUPON = "coupons/unassign";
export const REDEEM_COUPON = "coupons/redeem";
export const GET_AVAILABLE_COUPONS = "coupons/available";
export const GET_ELIGIBLE_USERS = "coupons/eligible-users";
export const GET_COUPON_ASSIGNMENTS = "coupons/assignments";
export const UPDATE_COUPON_QUANTITY = "coupons";
